import classNames from "classnames";
import { createUseStyles } from "react-jss";
import SectionBlock from "../SectionBlock";
import Card, { CardProps } from "../Card";
import Button from "../Button";

interface Props {
  id?: string;
  className?: string;
  header?: string;
  description?: string;
  cards: CardProps[];
  textAlign?: string;
  buttonLabel?: string;
  buttonOnClick?: () => void;
}

const useStyles = createUseStyles({
  root: {},
  cardGrid: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    "@media (max-width: 1024px)": {
      flexDirection: "column",
    },
  },
  sixth: {
    flexBasis: "15%",
  },
  hidden: {
    visibility: "hidden",
  },
});

const CardGrid = ({
  className,
  header,
  description,
  cards,
  textAlign,
  buttonLabel,
  buttonOnClick,
  id,
}: Props) => {
  const classes = useStyles();
  return (
    <div className={classNames(classes.root, className)} id={id}>
      <SectionBlock
        header={header}
        description={description}
        textAlign={textAlign}
      >
        <div className={classes.cardGrid}>
          {cards.length === 2 && (
            <div
              className={classNames({
                [classes.sixth]: cards.length === 2,
                [classes.hidden]: cards.length === 2,
              })}
            />
          )}
          {cards.map((card: CardProps) => (
            <Card
              icon={card.icon}
              header={card.header}
              description={card.description}
              key={card.header}
            />
          ))}
          {cards.length === 2 && (
            <div
              className={classNames({
                [classes.sixth]: cards.length === 2,
                [classes.hidden]: cards.length === 2,
              })}
            />
          )}
          {buttonLabel && buttonOnClick && (
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                marginTop: "50px",
                justifyContent: "center",
              }}
            >
              <Button label={buttonLabel} onClick={buttonOnClick} />
            </div>
          )}
        </div>
      </SectionBlock>
    </div>
  );
};

export default CardGrid;
